import React from 'react'
import { useTranslation } from 'react-i18next'
import { SectionShell } from '../shared/SectionShell'
import { RichText } from '../shared/RichText'

function IconCpu() {
    return (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <rect x="4" y="4" width="16" height="16" rx="2" />
            <rect x="9" y="9" width="6" height="6" />
            <line x1="9" y1="1" x2="9" y2="4" />
            <line x1="15" y1="1" x2="15" y2="4" />
            <line x1="9" y1="20" x2="9" y2="23" />
            <line x1="15" y1="20" x2="15" y2="23" />
            <line x1="20" y1="9" x2="23" y2="9" />
            <line x1="20" y1="14" x2="23" y2="14" />
            <line x1="1" y1="9" x2="4" y2="9" />
            <line x1="1" y1="14" x2="4" y2="14" />
        </svg>
    )
}

function IconLayers() {
    return (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <polygon points="12 2 2 7 12 12 22 7 12 2" />
            <polyline points="2 17 12 22 22 17" />
            <polyline points="2 12 12 17 22 12" />
        </svg>
    )
}

function IconCode() {
    return (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <polyline points="16 18 22 12 16 6" />
            <polyline points="8 6 2 12 8 18" />
        </svg>
    )
}

function IconTerminal() {
    return (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <polyline points="4 17 10 11 4 5" />
            <line x1="12" y1="19" x2="20" y2="19" />
        </svg>
    )
}

function IconNetwork() {
    return (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <circle cx="12" cy="5" r="2" />
            <circle cx="5" cy="19" r="2" />
            <circle cx="19" cy="19" r="2" />
            <line x1="12" y1="7" x2="12" y2="14" />
            <line x1="12" y1="14" x2="5" y2="17" />
            <line x1="12" y1="14" x2="19" y2="17" />
        </svg>
    )
}

function IconGauge() {
    return (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M12 2a10 10 0 0 1 7.74 16.33" />
            <path d="M4.26 18.33A10 10 0 0 1 12 2" />
            <line x1="12" y1="12" x2="16" y2="8" />
            <circle cx="12" cy="12" r="1.5" fill="currentColor" />
        </svg>
    )
}

const CAPABILITIES = [
    { key: 'capabilities.c1', Icon: IconCpu },
    { key: 'capabilities.c2', Icon: IconLayers },
    { key: 'capabilities.c3', Icon: IconCode },
    { key: 'capabilities.c4', Icon: IconNetwork },
    { key: 'capabilities.c5', Icon: IconTerminal },
    { key: 'capabilities.c6', Icon: IconGauge },
]

export default function CapabilitiesSection() {
    const { t } = useTranslation()

    return (
        <SectionShell id="capabilities">
            <div className="section-head">
                <span className="section-num">04</span>
                <span className="section-label">{t('capabilities.label')}</span>
            </div>

            <RichText
                i18nKey="capabilities.intro"
                as="h2"
                className="display-h2 capabilities-intro"
            />

            <div className="capabilities-grid">
                {CAPABILITIES.map(({ key, Icon }, i) => (
                    <div key={key} className="capability-card" style={{ animationDelay: `${i * 80}ms` }}>
                        <div className="capability-icon-wrap">
                            <Icon />
                        </div>
                        <p className="capability-label">{t(key)}</p>
                    </div>
                ))}
            </div>
        </SectionShell>
    )
}
